import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';

import getLeads from '../services/lead/getAllLeads';
import getUser from '../services/user/getUser';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    marginBottom: '30px',
  },
  table: {
    minWidth: 400,
  },
});

const columnData = [
  {
    id: 'name',
    sortKey: 'leadName',
    numeric: false,
    disablePadding: true,
    label: 'Name',
  },
  {
    id: 'phoneNumber',
    sortKey: 'leadPhoneNumber',
    numeric: false,
    disablePadding: false,
    label: 'Phone Number',
  },
  {
    id: 'address',
    sortKey: 'listingAddress',
    numeric: false,
    disablePadding: false,
    label: 'Listing Address',
  },
  {
    id: 'createdAt',
    sortKey: 'updatedAt',
    numeric: false,
    disablePadding: false,
    label: 'Created At',
  },
];

class LeadsHead extends Component {
  render() {
    return (
      <TableHead>
        <TableRow>
          {columnData.map(column => {
            return (
              <TableCell
                key={column.id}
                numeric={column.numeric}
                onClick={this.props.sortData(column.sortKey)}
              >
                {column.label}
                <i
                  className={`fa ${
                    this.props.isAccending ? 'fa-arrow-up' : 'fa-arrow-down'
                  }`}
                  style={{ marginLeft: '5px' }}
                />
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

class Leads extends Component {
  state = {
    leads: [],
    isAccending: true,
  };
  async componentDidMount() {
    try {
      const user = await getUser();
      const leads = await getLeads(user.teamId);
      this.setState({
        leads: leads.result,
      });
    } catch (e) {
      alert(e.message);
      this.setState({
        leads: [],
      });
    }
  }

  sortData = sortKey => () => {
    const { leads, isAccending } = this.state;
    leads.sort((a, b) => {
      if (sortKey === 'listingAddress') {
        a = a[sortKey].line1;
        b = b[sortKey].line1;
      } else {
        a = a[sortKey];
        b = b[sortKey];
      }

      if (isAccending) {
        if (a < b) {
          return -1;
        } else if (a > b) {
          return 1;
        }
      } else {
        if (a < b) {
          return 1;
        } else if (a > b) {
          return -1;
        }
      }

      return 0;
    });
    this.setState({ leads, isAccending: !isAccending });
  };

  render() {
    const { classes } = this.props;
    const { leads, isAccending } = this.state;

    return (
      <div>
        <h2>Leads</h2>
        <Divider />
        <Paper className={classes.root}>
          <div className={classes.tableWrapper}>
            <Table className={classes.table} aria-labelledby="tableTitle">
              <LeadsHead sortData={this.sortData} isAccending={isAccending} />
              <TableBody>
                {leads.map(lead => {
                  return (
                    <TableRow hover tabIndex={-1} key={lead.leadId}>
                      <TableCell>{lead.leadName}</TableCell>
                      <TableCell>{lead.leadPhoneNumber}</TableCell>
                      <TableCell>{lead.listingAddress.line1}</TableCell>
                      <TableCell>{moment(lead.updatedAt).fromNow()}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        </Paper>
      </div>
    );
  }
}

export default withStyles(styles)(Leads);



// WEBPACK FOOTER //
// ./src/components/Leads.js